import * as React from "react";
const SvgX = (props) => (
  <svg
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.326 0H20.7l-7.37 8.423L22 19.886h-6.789l-5.317-6.952-6.084 6.952H.434l7.883-9.01L0 0h6.961l4.806 6.354L17.327 0Zm-1.184 17.867h1.87L5.945 1.913H3.94l12.203 15.954Z"
      fill="#fff"
    />
  </svg>
);
export default SvgX;
